// Vitals API client (mind + body). Mirrors FinanceService's auth pattern.
// The payloads are already card-shaped (see VITALS in serga-os/data.js).

const API_BASE_URL = "https://api.serga.ba";

export interface MindDoc {
  schemaVersion?: number;
  scale?: number;
  labels?: string[];
  today: number | null;
  note?: string;
  todayDate?: string | null;
  log: Array<{ d: string; v: number; n?: string }>;
}

export interface BodyDoc {
  schemaVersion?: number;
  gauges: Array<{
    id: string;
    label: string;
    glyph?: string;
    value: number;
    unit?: string;
    min: number;
    max: number;
    target: number;
    invert?: boolean;
    hint?: string;
    trend?: number[];
  }>;
  workoutsWk?: number;
}

export interface VitalsView {
  mind: MindDoc | null;
  body: BodyDoc | null;
}

export class VitalsService {
  private static authTokens: any = null;

  static setAuthTokens(tokens: any) {
    this.authTokens = tokens;
  }

  private static getAuthHeaders() {
    if (!this.authTokens?.idToken) {
      throw new Error("No authentication token available");
    }
    return {
      Authorization: `Bearer ${this.authTokens.idToken}`,
      "Content-Type": "application/json",
    };
  }

  /** Aggregate { mind, body }, or null when nothing is stored yet (pending). */
  static async getVitals(): Promise<VitalsView | null> {
    const res = await fetch(`${API_BASE_URL}/vitals`, { headers: this.getAuthHeaders() });
    if (!res.ok) throw new Error(`Request failed: ${res.status}`);
    const data = await res.json();
    if (!data || data.pending) return null;
    return data as VitalsView;
  }

  /** Write the daily check-in (mood + journal + history). Returns the stored doc. */
  static async putMind(doc: MindDoc): Promise<MindDoc> {
    const res = await fetch(`${API_BASE_URL}/vitals/mind`, {
      method: "PUT",
      headers: this.getAuthHeaders(),
      body: JSON.stringify(doc),
    });
    if (!res.ok) {
      const text = await res.text();
      let msg = `Request failed: ${res.status}`;
      try {
        const p = JSON.parse(text);
        if (p.error) msg = p.error;
      } catch {}
      throw new Error(msg);
    }
    return res.json();
  }
}
